export const CloseBtn = () => {
    return (
        <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1728_3893)">
                <rect width="30" height="30" rx="2" fill="white" />
                <path
                    d="M11.0886 11.2157L11.1464 11.1464C11.32 10.9729 11.5894 10.9536 11.7843 11.0886L11.8536 11.1464L15 14.293L18.1464 11.1464C18.3417 10.9512 18.6583 10.9512 18.8536 11.1464C19.0488 11.3417 19.0488 11.6583 18.8536 11.8536L15.707 15L18.8536 18.1464C19.0271 18.32 19.0464 18.5894 18.9114 18.7843L18.8536 18.8536C18.68 19.0271 18.4106 19.0464 18.2157 18.9114L18.1464 18.8536L15 15.707L11.8536 18.8536C11.6583 19.0488 11.3417 19.0488 11.1464 18.8536C10.9512 18.6583 10.9512 18.3417 11.1464 18.1464L14.293 15L11.1464 11.8536C10.9729 11.68 10.9536 11.4106 11.0886 11.2157L11.1464 11.1464L11.0886 11.2157Z"
                    fill="#212121"
                />
                <rect x="0.5" y="0.5" width="29" height="29" rx="1.5" stroke="#D9D9D9" />
            </g>
            <defs>
                <filter
                    id="filter0_d_1728_3893"
                    x="0"
                    y="0"
                    width="30"
                    height="32"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1728_3893" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1728_3893" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
